import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./WhoIsMyrtleHeader.css"; // Custom CSS for exact styling

const WhoIsMyrtleHeader = () => {
  return (
    <>
      <div className="whoandwhyhead-container">
        <Row className="whoandwhyhead-row container-fluid">
          <Col lg={5} md={12} className="whoandwhyhead-text">
            <h6 className="whoandwhyhead-subtitle">Who we are</h6>

            <p
              className="whoandwhyhead-description"
              style={{ color: "white", fontFamily: "Helvetica" }}
            >
              A conglomerate of entrepreneurs with over two decades of
              experience in the three ABC's (Adjudication│Billing │ Coding) of
              the US healthcare revenue cycle & managed some of the bigger payer
              and provider groups at various levels.
            </p>
          </Col>
          <Col lg={5} md={12} className="whoandwhyhead-text">
            <h6 className="whoandwhyhead-subtitle">Why Myrtle</h6>

            <p
              className="whoandwhyhead-description"
              style={{ color: "white", fontFamily: "Helvetica" }}
            >
              We invite you to take few moments to explore the insights we've
              shared here, offering a glimpse into our approach. We are
              committed to fulfilling your needs and ensuring your satisfaction,
              with the ultimate goal of bringing a smile to your face.
            </p>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default WhoIsMyrtleHeader;
